import { UniqIdsPlugin, createUniqIdsMixin } from './vue-uniq-ids.js'

export { UniqIdsPlugin, createUniqIdsMixin }
export default UniqIdsPlugin
